<template>
  <div class="el-table-container templateBox">
    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
             @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
      <el-form-item label="关键字" prop="keyWord">
        <el-input v-model.trim="searchForm.keyWord" maxlength="20" placeholder="请输入关键字(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
      <el-form-item class="f_r">
        <el-button v-if="hasPermission('sys:identityManage:identityManage:logout')" type="danger" size="small"
                   @click="logout()">强制登出
        </el-button>
      </el-form-item>
    </el-form>
    <div class="tips">
      <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
      已选择{{ dataListSelect.length }}项数据
    </div>
    <el-table
        :data="dataList"
        v-loading="loading"
        size="small" height="100%"
        class="table" border
        ref="multipleTable"
        :row-key="'id'"
        @sort-change="sortChangeHandle"
        @selection-change="selectionChangeHandle"
    >
      <el-table-column :reserve-selection="true" type="selection" width="50"/>
      <el-table-column prop="image" label="头像" width="150px">
        <template slot-scope="{row}">
          <el-image
              style="width: 100px; height: 100px;border-radius: 50%"
              :src="row.image"
              :preview-src-list="[row.image]"
              fit="fill"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="登陆账号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mobilePhone" label="用户名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="loginStatus" label="登陆状态" show-overflow-tooltip></el-table-column>
      <el-table-column prop="loginIp" label="最近登陆IP" show-overflow-tooltip></el-table-column>
      <el-table-column prop="longinData" sortable="custom" label="最近登陆时间" show-overflow-tooltip></el-table-column>
      <el-table-column min-width="100px" fixed="right" label="操作">
        <template slot-scope="{row}">
          <el-button v-if="hasPermission('sys:identityManage:identityManage:logout')" type="text"
                     size="small" @click="logout(row)">强制登出
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                @pagination="refreshList"/>
  </div>
</template>

<script>

export default {
  name: "identityManage",
  data() {
    return {
      searchForm: {
        keyWord: '',
        sort: '',
        current: 1,
        size: 20,
      },
      total: 0,

      loading: false,
      dataList: [],
      dataListSelect: [],
    }
  },

  mounted() {
    this.refreshList()
  },

  methods: {
    // 获取数据列表 current查第几页数据
    refreshList(type, clearSelect) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      if (clearSelect) {
        this.$refs.multipleTable.clearSelection()
      }
      this.loading = true
      this.$axios(this.api.user.sysAuthenticationQueryAuthenticationList, this.searchForm).then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length == 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },

    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.refreshList(1, 1)
    },

    //表格勾选数据
    selectionChangeHandle(val) {
      this.dataListSelect = val
    },

    // 排序
    sortChangeHandle(obj) {
      if (obj.order === 'ascending') {
        this.searchForm.sort ='asc'
      } else if (obj.order === 'descending') {
        this.searchForm.sort = 'desc'
      } else {
        this.searchForm.sort = ''
      }
      this.refreshList(1, 1)
    },

    //强制登出
    logout(row) {
      let list = row ? [row] : this.dataListSelect
      if (list.length == 0) {
        this.$message.warning('请至少选择一个用户')
        return
      }
      let ids = list.map(item => {
        return item.id
      })
      this.$confirm(`强制登出后，该账号将自动登出系统`, '确认强制登出所选账号？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.user.sysAuthenticationExitByUserIds, ids, 'post').then(data => {
          if (data && data.status) {
            this.$message.success('强制登出成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },


  },
}
</script>

<style scoped>
</style>
